import {
  PRODUCTTAG_LOADING,
  GET_PRODUCTTAG,
  GET_PRODUCTTAG_SUCCESS,
  GET_PRODUCTTAG_FAIL,
  ADD_PRODUCTTAG_SUCCESS,
  ADD_PRODUCTTAG_FAIL,
  DELETE_PRODUCTTAG_SUCCESS,
  DELETE_PRODUCTTAG_FAIL,
  UPDATE_PRODUCTTAG_SUCCESS,
  UPDATE_PRODUCTTAG_FAIL
} from "./actionType";

const INIT_STATE = {
  productTags: [],
  error: {},
};

const ProductTag = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTTAG_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTTAG:
          return {
            ...state,
            productTags: action.payload.data,
            isProductTagCreated: false,
            isProductTagSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTTAG_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTTAG_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductTagCreated: false,
            isProductTagSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTTAG: {
      return {
        ...state,
        isProductTagCreated: false,
        loading: true,
      };
    }

    case PRODUCTTAG_LOADING: {
      return {
        ...state,
        isProductTagCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTTAG_SUCCESS:
      return {
        ...state,
        isProductTagCreated: true,
        loading: false,
        productTags: [action.payload.data, ...state.productTags],
      };

    case ADD_PRODUCTTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        productTags: state.productTags.filter(
          productTag => productTag.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        productTags: state.productTags.map(productTag =>
          productTag.id.toString() === action.payload.data.id.toString() ? { ...productTag, ...action.payload.data } : productTag
        ),
      };

    case UPDATE_PRODUCTTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default ProductTag;